'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const universal_color = require('../../style/universal.color.js');

var mlbGrey7 = universal_color.mlbGrey7,
  skeletonLightMain = universal_color.skeletonLightMain,
  skeletonLightHighlight = universal_color.skeletonLightHighlight,
  skeletonDarkHighlight = universal_color.skeletonDarkHighlight;
var SkeletonColors = {
  primary: {
    main: skeletonLightMain,
    highlight: skeletonLightHighlight
  },
  dark: {
    main: mlbGrey7,
    highlight: skeletonDarkHighlight
  }
};

exports.SkeletonColors = SkeletonColors;
